import { render, staticRenderFns } from "./OpenIdConnect.vue?vue&type=template&id=4abd01c1&scoped=true&"
import script from "./OpenIdConnect.vue?vue&type=script&lang=ts&"
export * from "./OpenIdConnect.vue?vue&type=script&lang=ts&"
import style0 from "./OpenIdConnect.vue?vue&type=style&index=0&id=4abd01c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd01c1",
  null
  
)

export default component.exports